import type { Settings } from '@vgn-medien-holding/vgn-fe-components';

export const settings: Settings = {
  avatarFallbackUrl: '/assets/author-transparent.svg',
  logoUrl: '/assets/logos/tvm/logo.png',
};
